import { createAction } from 'redux-actions';
export const setShowSuggestionModal = createAction('SET_SHOW_SUGGESTION_MODAL');
export const toggleShowSuggestionModal = createAction('TOGGLE_SHOW_SUGGESTION_MODAL');
